import React from 'react'

const GraphSection = () => {
    return (
        <div className=''>
            <div className='w-full h-full  md:hidden'>
                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%208346.png?updatedAt=1695900170324" width={300} height={365} alt="graph" className='w-full h-auto'/>
            </div>
            <div className='w-full h-full hidden md:block'>
                <img alt="a line graph showing the growth of a cell phone" src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%209125.png?updatedAt=1694700393696" width={300} height={365}  className='w-full h-auto'/>
            </div>
        </div>
    )
}

export default GraphSection